import React, { Component } from "react";
import ServerError from "./ServerError";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log error if needed
    console.error("ErrorBoundary caught an error", error, info);
  }

  render() {
    if (this.state.hasError) {
      return <ServerError />
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
